export default "__VITE_ASSET__9537b65f__"